/* @jsxImportSource react */

import clsx from 'clsx';

import type { SlotPriority } from './types';

export const SlotLoading = ({
  className,
  priority,
}: {
  priority: SlotPriority;
  className?: string;
}) => (
  <div
    className={clsx(
      `slot-mobile-priority-${priority} flex animate-pulse flex-col items-center py-1`,
      className,
    )}
  >
    <div className="bg-color-grey-light h-[32px] w-[32px] rounded-md" />
    <div className="h-[var(--body-xs-lineheight)] w-[64px] pt-0.5 max-lg:hidden">
      <div className="bg-color-grey-light h-full rounded-sm" />
    </div>
  </div>
);
